import axios from 'axios'
import fetch from 'cross-fetch'
import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'
import i18n from '@/i18n'

export const hereMapsService = {
  getAddressSuggestions,
  getAdressDetail,
  getCoordinatesBasedOnAddressText,
  searchLocationByString,
  hereMapsPlatform,
  hereMapsRouting,
  hereMapsDefaultLayer,
  hereMapsDomIcons,
  hereMap,
  hereMapsBehaviors,
  hereMapsUI,
  hereMapsMarker,

}

const SEARCH_LOCATION_BY_STRING = gql`query searchLocationByString($input: SearchLocationByStringInput!) {
  searchLocationByString(input: $input) {
    address
    coordinates
  }
}`

const searchCoordinatesLocationUrl = 'https://y48sjynp2f.execute-api.eu-west-1.amazonaws.com/dev/search'

async function getCoordinatesBasedOnAddressText ({ addressObject }) {
  return new Promise((resolve, reject) => {
    const addressText = Object.values(addressObject).join('+')
    axios.get(`${searchCoordinatesLocationUrl}?searchtext=${addressText}`).then((response) => {
      resolve(response)
    }).catch((error) => {
      if (error) {
        if (addressObject.street_number === '') {
          let addressTextWithoutStreetArray = []
          Object.keys(addressObject).forEach((key) => {
            if (key !== 'street' && key !== 'street_number') {
              addressTextWithoutStreetArray.push(addressObject[key])
            }
          })
          return axios.get(`${searchCoordinatesLocationUrl}?searchtext=${addressTextWithoutStreetArray.join('+')}`)
        }
      } else {
        reject(error)
      }
    }).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

function getUrlForAddressSuggestions (query) {
  const baseURL = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json'
  return `${baseURL}?app_id=${process.env.VUE_APP_HERE_MAP_APP_ID}&app_code=${process.env.VUE_APP_HERE_MAP_APP_CODE}&query=${query}&language=${i18n.locale}`
}
function getUrlForAddressGeocode (query) {
  const baseURL = 'https://geocoder.api.here.com/6.2/geocode.json'
  return `${baseURL}?app_id=${process.env.VUE_APP_HERE_MAP_APP_ID}&app_code=${process.env.VUE_APP_HERE_MAP_APP_CODE}&searchtext=${query}&language=${i18n.locale}`
}

async function getAddressSuggestions (query) {
  return new Promise ((resolve, reject) => {
    const url = getUrlForAddressSuggestions(query)
    fetch(url).then((response) => {
      return response.json()
    }).then((data) => {
      if (data.suggestions.length > 0) {
        resolve(data.suggestions)
      }
      const geocodeUrl = getUrlForAddressGeocode(query, {
        mode: 'no-cors'
      })
      return fetch(geocodeUrl)
    }).then((response) => {
      return response.json()
    }).then((data) => {
      if (data.Response != null) {
        if (data.Response.View[0] != null) {
          if (data.Response.View[0].Result[0] != null) {
            let location = {}
            Object.keys(data.Response.View[0].Result[0].Location.Address).forEach((key) => {
              if (key !== 'AdditionalData' )
              location[key.toLowerCase()] = data.Response.View[0].Result[0].Location.Address[key]
            })
            resolve([{ address: location, label: location['label'], locationId:  data.Response.View[0].Result[0].Location.LocationId}])
          }
        }
      }
      resolve([])
    }).catch((error) => {
      console.error(error)
      resolve([])
    })
  })

  // const suggestions = await response.json()
  // if (suggestions.length < 1) {
  //   const geocodeUrl = getUrlForAddressGeocode(query)
  //   const geocodeResponse = await fetch(geocodeUrl)
  //   const data = await geocodeResponse.json()
  //   return data
  // }
  // return suggestions
}

function getUrlForAddressDetail (locationId) {
  const baseURL = 'https://geocoder.api.here.com/6.2/geocode.json'
  return `${baseURL}?app_id=${process.env.VUE_APP_HERE_MAP_APP_ID}&app_code=${process.env.VUE_APP_HERE_MAP_APP_CODE}&locationid=${locationId}&jsonattributes=1`
}

async function getAdressDetail (locationId) {
  let suggestions = []
  const url = getUrlForAddressDetail(locationId)
  let response = await fetch(url)

  suggestions = await response.json()

  return suggestions
}

async function searchLocationByString ({ language, searchText }) {
  try {
    const response = await appSync.query({
      query: SEARCH_LOCATION_BY_STRING,
      variables: {
        input: {
          language,
          searchText
        }
      }
    })
    return response.data.searchLocationByString
  } catch (error) {
    return Promise.reject(error)
  }
}

/** Here maps initialization */
function hereMapsPlatform () {
  const herePlatform = new window.H.service.Platform({
    apikey: 'nnuTL4coE1diqkZ9mDdzC7shaHo7hJrtZmeHfd1mRzU',
    app_code: 'PROD-de11fa5f-5a46-49b7-bdc9-b09879cdb583',
    useCIT: true,
    useHTTPS: true
  })
  return herePlatform
}

function hereMapsDefaultLayer ({ platform, lg = i18n.locale }) {
  const defaultLayer = platform.createDefaultLayers({
    lg
  })
  return defaultLayer
}

async function hereMapsRouting ({ platform }) {
  try {
    const response = platform.getRoutingService(null, 8)
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

function hereMapsDomIcons ({ files = [] }) {
  return Promise.all(files.map(async (item) => {
    const response = await fetch(item.file).then(response => response.text())
    const domIcon = new window.H.map.DomIcon(response)
    return {
      name: item.name,
      domIcon: domIcon
    }
  }))
}
function hereMap ({ element, defaultLayer, zoom = 4, center = { lat: 49.2306525, lng: 16.59019349999994 }  }) {
  const hereMap = new window.H.Map(
    element,
    defaultLayer.vector.normal.map,
    {
      zoom,
      center,
      pixelRatio: window.devicePixelRatio || 1
    }
  )
  return hereMap
}

function hereMapsBehaviors ({ map }) {
  const mapEvents = new window.H.mapevents.MapEvents(map)
  const behaviors = new window.H.mapevents.Behavior(mapEvents)

  return behaviors
}

function hereMapsUI ({ defaultLayer, map }) {
  let mapUI = {
    source: null,
    mapSettings: null,
    zoom: null,
    scaleBar: null
  }
  mapUI.source = window.H.ui.UI.createDefault(map, defaultLayer)
  mapUI.mapSettings = mapUI.source.getControl('mapsettings')
  mapUI.zoom = mapUI.source.getControl('zoom')
  mapUI.scalebar = mapUI.source.getControl('scalebar')

  return mapUI
}

function hereMapsMarker ({ lat, lng, icon, location }) {
  const marker = new window.H.map.DomMarker(
    {
      lat,
      lng
    },
    { icon }
  )
  // marker.setData(
  //   `<div class="custom--timeline__body--card">
  // <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
  // ${location.organization != null ? location.organization.name : ''}
  // </span><span  class="custom--timeline__body--card--text__subtitle">
  // ${location.organization.ref}</span></div>
  // <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
  // ${this.$options.filters.AddressObjectToString(location.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}
  // </span><span  class="custom--timeline__body--card--text__subtitle">
  // ${location.ref}</span></div>
  // </div>`)
  return marker
}
